import React, { useState, useEffect, useRef } from "react";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "../LanguageContext";

import logo from "../assets/landing/logomel.jpeg";
import dasImg from "../assets/products/das/DAS.png";
import das48Img from "../assets/products/das/DAS48.png";
import dmsImg from "../assets/products/dms/dms.png";
import bmsImg from "../assets/products/bms/bms.png";
import monImg from "../assets/products/monkwh/monkwh putih.jpg";
import minidcuImg from "../assets/products/dcu/minidcu.png";
import watermeterImg from "../assets/products/watermeter/watermeter.png";
import hmiImg from "../assets/products/hmi/hmimonkwh.png";
import hmidasImg from "../assets/products/hmi/hmi.png";
import hmiscadaImg from "../assets/products/hmi/hmiscada.png";
import imagenot from "../assets/products/imagenot.jpg";

export default function Navbar() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("Home");
  const [dropdownContent, setDropdownContent] = useState(null);
  const navigate = useNavigate();
  const location = useLocation(); 
  const { language, toggleLanguage } = useLanguage();
  const navbarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setDropdownContent(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith("/product")) {
      setActiveMenu(language === "id" ? "Produk & Portofolio" : "Product & Portfolio");
    }
  }, [location, language]);

  const text = {
    id: {
      home: "Beranda",
      journey: "Perjalanan Kami",
      product: "Produk",
      activities: "Kegiatan Kami",
      dropdown: {
        product: "PRODUK",
        // portfolio: "Portofolio",
        hardware: "Perangkat Keras",
        software: "Perangkat Lunak",
      },
    },
    en: {
      home: "Home",
      journey: "Our Journey",
      product: "Product",
      activities: "Our Activities",
      dropdown: {
        product: "PRODUCT",
        // portfolio: "Portfolio",
        hardware: "Hardware",
        software: "Software",
      },
    },
  };
  const t = text[language] || text.en;

  const dropdownData = {
    Product: [
      { name: "DAS24P", img: dasImg, desc_id: "Sistem Peringatan Digital", desc_en: "Digital Alert System" },
      { name: "DAS48", img: das48Img, desc_id: "Sistem Peringatan Digital", desc_en: "Digital Alert System" },
      { name: "DMS", img: dmsImg, desc_id: "Sistem Pemantauan Perangkat", desc_en: "Device Monitoring System" },
      { name: "BMS", img: bmsImg, desc_id: "Sistem Pemantauan Baterai", desc_en: "Battery Monitoring System" },
      { name: "MonKWH", img: monImg, desc_id: "Pemantauan Energi", desc_en: "Energy Monitoring" },
      { name: "Mini DCU", img: minidcuImg, desc_id: "Unit Konsentrator Data", desc_en: "Data Concentrator Unit" },
      { name: "Water Meter", img: watermeterImg, desc_id: "Pengukur Air", desc_en: "Water Measurement" },
      { name: "HMI IOT", img: hmiImg, desc_id: "Dashboard Pemantauan IOT", desc_en: "IOT Monitoring Dashboard" },
      { name: "HMI OMC", img: hmidasImg, desc_id: "Pusat Operasi Pemeliharaan HMI - OMC", desc_en: "HMI Operation Maintenance Center - OMC" },
      { name: "HMI SCADA", img: hmiscadaImg, desc_id: "Antarmuka Sistem Pemantauan SCADA Air ", desc_en: "The SCADA Air Monitoring System" },
    ],
    Hardware: [
      { name: "DAS24P", img: dasImg, desc_id: "Sistem Peringatan Digital", desc_en: "Digital Alert System" },
      { name: "DAS48P", img: das48Img, desc_id: "Sistem Peringatan Digital", desc_en: "Digital Alert System" },
      { name: "DMS", img: dmsImg, desc_id: "Sistem Pemantauan Perangkat", desc_en: "Device Monitoring System" },
      { name: "BMS", img: bmsImg, desc_id: "Sistem Pemantauan Baterai", desc_en: "Battery Monitoring System" },
      { name: "MonKWH", img: monImg, desc_id: "Pemantauan Energi", desc_en: "Energy Monitoring" },
      { name: "Mini DCU", img: minidcuImg, desc_id: "Unit Konsentrator Data", desc_en: "Data Concentrator Unit" },
      { name: "Water Meter", img: watermeterImg, desc_id: "Pengendali Data Utama", desc_en: "Main Data Controller" },
    ],
    Software: [
      { name: "HMI OMC", img: hmiImg,desc_id: "Dashboard Pemantauan IOT", desc_en: "IOT Monitoring Dashboard" },
      { name: "HMI DAS", img: hmidasImg, desc_id: "Pusat Operasi Pemeliharaan HMI - OMC", desc_en: "HMI Operation Maintenance Center - OMC" },
      { name: "HMI SCADA", img: hmiscadaImg, desc_id: "Antarmuka Sistem Pemantauan SCADA Air ", desc_en: "The SCADA Air Monitoring System" },
    ],
    // Portfolio: [
    //   { name: "Proyek PLN", img: imagenot, desc_id: "Sistem Smart Grid", desc_en: "Smart Grid System" },
    //   { name: "Platform IoT", img: imagenot, desc_id: "Integrasi IoT Kustom", desc_en: "Custom IoT Integration" },
    // ],
  };

  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
    setIsSidebarOpen(false);
    setDropdownContent(null);

    const targetId =
      menu === t.home ? "home" :
      menu === t.journey ? "journey" :
      menu === t.activities ? "activities" : null;

    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        if (targetId) {
          const section = document.getElementById(targetId);
          if (section) section.scrollIntoView({ behavior: "smooth" });
        }
      }, 600);
    } else if (targetId) {
      const section = document.getElementById(targetId);
      if (section) section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div ref={navbarRef} className="relative font-open_sans">
      {dropdownContent && !isSidebarOpen && (
        <div
          className="hidden lg:block fixed inset-0 bg-black/40 backdrop-blur-sm z-20"
          onClick={() => setDropdownContent(null)}
        />
      )}

      {isSidebarOpen && (
        <>
          <div
            className="lg:hidden fixed inset-0 bg-black/40 backdrop-blur-sm z-40"
            onClick={() => setIsSidebarOpen(false)}
          ></div>
          <div className="fixed top-0 right-0 w-3/4 sm:w-1/2 h-full bg-white z-50 shadow-lg transition-transform transform animate-slideIn">
            <div className="flex justify-between items-center p-4 border-b">
              <img
                src={logo}
                alt="Logo"
                className="h-8 cursor-pointer"
                onClick={() => {
                  navigate("/");
                  setIsSidebarOpen(false);
                  setDropdownContent(null);
                }}
              />
              <button
                onClick={() => setIsSidebarOpen(false)}
                className="text-gray-600 hover:text-blue-600"
              >
                ✕
              </button>
            </div>

            <ul className="flex flex-col p-6 space-y-4 text-gray-800">
              {[t.home, t.journey, t.activities].map((menu) => (
                <li key={menu}>
                  <button
                    onClick={() => handleMenuClick(menu)}
                    className={`block w-full text-left py-2 px-3 rounded-lg hover:bg-gray-100 ${
                      activeMenu === menu ? "text-blue-600 font-semibold" : ""
                    }`}
                  >
                    {menu}
                  </button>
                </li>
              ))}

              <li>
                <details className="group" open={activeMenu === t.product}>
                  <summary
                    className={`cursor-pointer py-2 px-3 rounded-lg hover:bg-gray-100 font-semibold transition ${
                      activeMenu === t.product ? "text-blue-600" : "text-gray-800"
                    }`}
                  >
                    {t.product}
                  </summary>

                  <div className="pl-4 mt-2 space-y-4 overflow-y-auto max-h-[60vh]">
                    {Object.entries(dropdownData).map(([category, items]) => (
                      <div key={category}>
                        <p className="text-sm font-bold text-gray-700 mb-2">
                          {t.dropdown[category.toLowerCase()]}
                        </p>
                        <div className="flex flex-col space-y-3">
                          {items.map((item) => (
                            <RouterLink
                              key={item.name}
                              to={`/product/${item.name.toLowerCase().replace(/\s+/g, "")}`}
                              onClick={() => setIsSidebarOpen(false)}
                              className="flex items-center gap-3 p-2 rounded-md hover:bg-gray-100"
                            >
                              <img
                                src={item.img}
                                alt={item.name}
                                className="h-10 w-10 object-contain rounded-md border border-gray-200"
                              />
                              <div className="flex flex-col">
                                <span className="text-sm font-semibold text-gray-800">
                                  {item.name}
                                </span>
                                <span className="text-xs text-gray-500">
                                  {language === "id" ? item.desc_id : item.desc_en}
                                </span>
                              </div>
                            </RouterLink>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </details>
              </li>
            </ul>
          </div>
        </>
      )}

      <nav className="fixed top-0 left-0 w-full bg-white shadow-sm z-50">
        <div className="max-w-7xl mx-auto flex justify-between items-center px-4 py-3 text-gray-800">
          <button
            onClick={() => {
              navigate("/");
              setActiveMenu(t.home);
              setDropdownContent(null);
              setIsSidebarOpen(false);
            }}
          >
            <img src={logo} alt="Logo" className="h-8" />
          </button>

          <div className="flex items-center lg:hidden">
            <button
              onClick={toggleLanguage}
              className="px-3 py-1 mr-4 border border-gray-300 rounded-lg text-sm hover:bg-gray-100 transition"
            >
              {language === "id" ? "EN" : "ID"}
            </button>
            <button
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              className="text-gray-600 hover:text-blue-600"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>

          <ul className="hidden lg:flex space-x-8 items-center">
            {[t.home, t.journey, t.activities].map((menu) => (
              <li key={menu} onMouseEnter={() => setDropdownContent(null)}>
                <span
                  onClick={() => handleMenuClick(menu)}
                  className={`cursor-pointer hover:text-blue-600 ${
                    activeMenu === menu ? "text-blue-600 font-bold" : ""
                  }`}
                >
                  {menu}
                </span>
              </li>
            ))}

            <li
              onMouseEnter={() => {
                setActiveMenu(t.product);
                setDropdownContent("Product");
              }}
              className={`cursor-pointer hover:text-blue-600 ${
                activeMenu === t.product ? "text-blue-600 font-bold" : ""
              }`}
            >
              {t.product}
            </li>

            <li>
              <button
                onClick={toggleLanguage}
                className="ml-4 px-3 py-1 border border-gray-300 rounded-lg text-sm hover:bg-gray-100 transition"
              >
                {language === "id" ? "EN" : "ID"}
              </button>
            </li>
          </ul>
        </div>
      </nav>

      {dropdownContent && !isSidebarOpen && (
        <div
          className="hidden lg:block fixed top-[50px] left-0 w-full bg-white z-30 shadow-xl animate-fadeIn"
          onMouseEnter={() => setDropdownContent(dropdownContent)}
          onMouseLeave={() => setDropdownContent(null)}
        >
          <div className="max-w-6xl mx-auto px-8 py-8 flex">
            <div className="w-1/5 border-r pr-6 space-y-4">
              {["Product", "Hardware", "Software", "Portfolio"].map((category) => (
                <h3
                  key={category}
                  onClick={() => setDropdownContent(category)}
                  className={`text-sm font-bold cursor-pointer ${
                    dropdownContent === category
                      ? "text-blue-700 border-l-2 border-blue-600 pl-2"
                      : "text-gray-800 hover:text-blue-600"
                  }`}
                >
                  {t.dropdown[category.toLowerCase()]}
                </h3>
              ))}
            </div>

            <div className="flex-1 grid grid-cols-5 gap-8 px-6">
              {dropdownData[dropdownContent]?.map((item) => (
                <RouterLink
                  key={item.name}
                  to={`/product/${item.name.toLowerCase().replace(/\s+/g, "")}`}
                  onClick={() => setDropdownContent(null)}
                  className="text-center hover:bg-gray-50 p-2 rounded-lg transition block"
                >
                  <img
                    src={item.img}
                    alt={item.name}
                    className="h-16 mx-auto mb-3 object-contain transition-transform hover:scale-105"
                  />
                  <p className="font-semibold text-gray-800">{item.name}</p>
                  <p className="text-xs text-gray-500">
                    {language === "id" ? item.desc_id : item.desc_en}
                  </p>
                </RouterLink>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
